import { createFileRoute } from '@tanstack/react-router';
import RuleSet from '@views/DataUnification/RuleSetWrapper';
import { PAGE_PATHS, Permission } from '../../../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/data-entities/fields/set/$fieldName/{-$mode}/{-$id}/')({
  component: RuleSet,
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.DATA_UNIFICATION_FIELDS, permission: Permission.CREATE }) ||
      context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.DATA_UNIFICATION_FIELDS, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
